import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Inscription from '../Inscription';
import { ExternalLayout } from '../Layout/ExternalLayout';
import { FooterLinks } from '../Layout/FooterLinks';

export class RegistrationPage extends Component {
  static displayName = RegistrationPage.name;

  render () {
    document.title="Formulaire d'inscription";
    return (
      
      <div>
        <ExternalLayout />
        <Container className='px-0'>
          <Inscription/>
        </Container>
        <FooterLinks/>
      </div>
    );
  }
}
